import { Box, Grid2 } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import { ImageBox, PointsBox } from '../EducationForLife/CurriculumSection'
import { SummerCampImages } from '../../assets/img/summercamp/SummerCampImages'
import { getImageUrl } from '../../shared/utils/getImageUrl'


const HowWeAreDifferentSection = ({ howWeDifferenceData }) => {

    const benefitData1 = [
        {
            listItemTitle: "Apartment-Based Convenience",
            listItemContent:
                "Every grade has a defined checklist of “what the child must know,” making progress measurable and visible"
        },
        {
            listItemTitle: "Balanced Curriculum",
            listItemContent:
                "Unlike camps that focus only on art or only on sports, our camp blends creativity + physical activity  personality building, giving children holistic exposure"
        },
        {
            listItemTitle: "Hands-On Learning Approach",
            listItemContent:
                "Children learn by doing—not by watching. Every day has practical activities that spark imagination and curiosity"
        }
    ]

    const benefitData2 = [
        {
            listItemTitle: "Experienced & Child-Friendly Facilitators",
            listItemContent:
                "Every grade has a defined checklist of “what the child must know,” making progress measurable and visible"
        },
        {
            listItemTitle: "Skill Development Through Play",
            listItemContent:
                "We design activities with purpose—communication, creativity, confidence, body coordination, fine motor skills, teamwork and more"
        },
        {
            listItemTitle: "Screen-Free Engagement",
            listItemContent:
                "Kids are actively involved throughout the day, helping reduce screen time during holidays"
        },
        {
            listItemTitle: "Safe, Structured, and Highly Interactive",
            listItemContent:
                "Each session has clear objectives, safety protocols, and well-organized fun"
        },
    ]



    return (
        <Box>
            <Heading Heading={howWeDifferenceData?.heading} center />
            <CustomDivider size={"1rem"} />

            {/* SECTION 1 */}
            <Grid2 container>
                <ImageBox img={getImageUrl(howWeDifferenceData?.benefits?.[0]?.imageUrl)} />
                <PointsBox items={howWeDifferenceData?.benefits?.[0]?.list} />
            </Grid2>

            <CustomDivider />

            {/* SECTION 2 */}
            <Grid2 container>
                <PointsBox items={howWeDifferenceData?.benefits?.[1]?.list} direction="row-reverse" />
                <ImageBox img={getImageUrl(howWeDifferenceData?.benefits?.[1]?.imageUrl)} />
            </Grid2>
        </Box>
    )
}

export default HowWeAreDifferentSection
